export default __webpack_public_path__ + "static/media/sauce.f8b2481f.svg";